// extracted by mini-css-extract-plugin
module.exports = {"homeArticles":"style_homeArticles__4e_Na","btnList":"style_btnList__6CLwB","articleGridList":"style_articleGridList__bQRvF","articleGroup":"style_articleGroup__qlOSj"};